import { useIntl, defineMessages } from 'react-intl'

import { Select } from 'components/v2/Select'
import { COUNTRY_CODES } from 'utils/countries'
import { STATES, US_STATES } from 'utils/states'

const messages = defineMessages({
  selectStateCode: {
    id: 'dictionary.selectState',
    defaultMessage: 'Select state'
  }
})

export const SelectState = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()
  let countryStates = STATES
  if (props.country === COUNTRY_CODES.US) {
    countryStates = US_STATES
  }

  return (
    <Select {...props}>
      <option value="">{intl.formatMessage(messages.selectStateCode)}</option>

      {countryStates.map((state): TSFixMe => {
        return (
          <option value={state.code} key={state.code}>
            {state.name}
          </option>
        )
      })}
    </Select>
  )
}
